import React, {useEffect, useState} from 'react';
import {DialogContent} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ModalDialog from "./ModalDialog";
import {FloorPlanOption, OptionValue} from "../SharedTypes";
import Typography from "@material-ui/core/Typography";
import {getPriceDesc, inputStyles} from "../shared";
import TextField from '@material-ui/core/TextField';
import {makeStyles} from "@material-ui/core/styles";
import colors from '../colors.json';
import Autocomplete from "@material-ui/lab/Autocomplete";

export const colorMap: Record<string, string> = colors.reduce((obj, color) => ({...obj, [color.name]: color.hex}), {} as Record<string,string>);

const useStyles = makeStyles({
    input: inputStyles,
    colorPreview: {
        width: 24,
        height: 24,
        display: 'inline-block',
        borderRadius: '100%',
        marginRight: '1rem',
    }
});

export type Props = {
    floorPlanOption: FloorPlanOption | undefined
    optionValue: OptionValue | undefined
    submitLabel?: string
    fieldData?: any
    onCancel: () => void
    onSave: (fieldData: Record<string, string>) => void
}

function OptionValueDialog({
                               floorPlanOption,
                               optionValue,
                               onCancel,
                               onSave,
                               submitLabel,
                               fieldData: initialFieldData
                           }: Props) {
    const [fieldData, setFieldData] = useState(initialFieldData || {}),
        pricing = optionValue?.pricing,
        showCommentBox = optionValue?.showCommentBox,
        classes = useStyles();

    useEffect(() => {
        setFieldData(initialFieldData || {});
    }, [initialFieldData]);

    return (
        <ModalDialog open={Boolean(optionValue) && Boolean(floorPlanOption)} onClose={onCancel}
                     title={optionValue?.name} maxWidth="lg"
                     content={<>
                         <DialogContent>
                             <div style={{textAlign: 'center'}}>
                                 <img src={optionValue?.photo.url} alt={optionValue?.name} style={{maxWidth: '100%'}}/>
                             </div>
                             <Typography variant="subtitle1" component="p" color="textSecondary">
                                 {optionValue ? getPriceDesc(optionValue) : ''}
                             </Typography>
                             {(pricing?.maxQuantity && pricing?.maxQuantity > 1)
                                 ? <div style={{margin: '2rem 0'}}><TextField id="quantity" type="number"
                                                                              className={classes.input}
                                                                              label={pricing.unitName ? `Enter ${pricing.unitName}` : 'Quantity'}
                                                                              value={fieldData.quantity}
                                                                              onChange={e => setFieldData({
                                                                                  ...fieldData,
                                                                                  quantity: e.target.value
                                                                              })}
                                                                              inputProps={{
                                                                                  min: '1',
                                                                                  max: pricing.maxQuantity
                                                                              }}
                                 /></div> : null}
                             {(showCommentBox && !optionValue?.autoFillColors)
                                 ? <TextField id="commentBox" className={classes.input}
                                              label={optionValue?.commentBoxLabel || 'Comments'}
                                              value={fieldData.comments}
                                              onChange={e => setFieldData({
                                                  ...fieldData, comments: e.target.value
                                              })}
                                 /> : null}
                             {(showCommentBox && optionValue?.autoFillColors)
                                 ? <Autocomplete freeSolo id="commentBox-autocomplete"
                                                 disableClearable
                                                 options={colors.map((option) => option.name)}
                                                 renderOption={(option: any) => (<>
                                                     <div className={classes.colorPreview}
                                                          style={{backgroundColor: colorMap[option]}}/>
                                                     {option}
                                                 </>)}
                                                 renderInput={(params) => (
                                                     <TextField
                                                         {...params}
                                                         label={optionValue?.commentBoxLabel || 'Comments'}
                                                         margin="normal"
                                                         variant="outlined"
                                                         InputProps={{...params.InputProps, type: 'search'}}
                                                     />
                                                 )}
                                                 value={fieldData.comments}
                                                 onChange={(e, comments) => setFieldData({comments})}
                                 /> : null}
                             <div dangerouslySetInnerHTML={{__html: optionValue?.description || ''}}/>
                         </DialogContent>
                     </>}
                     actions={<>
                         <Button color="primary" onClick={() => {
                             onCancel();
                         }}>Back</Button>
                         <Button color="primary" variant="contained" onClick={() => {
                             if (optionValue) {
                                 onSave(fieldData);
                             } else {
                                 onCancel();
                             }
                         }}>{submitLabel || 'Add Option'}</Button>
                     </>}/>
    );
}

export default OptionValueDialog;